<template>
  <ul class="sidenav app-sidenav" :class="{ open: value }">
    <div class="user-view">
      <div class="background indigo lighten-3">
        
      </div>

      <a>
        <span class="white-text name">მომხმარებელი: {{ client.userName }}</span>
      </a>
      <a>
        <span class="white-text email">კომპანია: {{ client.carWashName }}</span>
      </a>
      <a class="closebtn indigo lighten-2" @click.prevent="$emit('menubackclick')">
        <i class="material-icons white-text">keyboard_backspace</i>
      </a>
    </div>

    <ul>
      <router-link
        v-for="link in links"
        :key="link.link"
        tag="li"
        :to="link.link"
      >
        <a href="#" class="waves-effect waves-orange pointer">
          {{ link.text }}
        </a>
      </router-link>
    </ul>
    <router-link tag="li" to="/contact" exact>
      <a href="#" class="waves-effect waves-orange pointer">კონტაქტი</a>
    </router-link>
  </ul>
</template>
<script>
export default {
  props: ["value"],
  data: () => ({
    client: {
      carWashName: null,
      userName: null,
      profileLink: null,
    },
    links: [],
  }),
  mounted() {
    const User = JSON.parse(localStorage.getItem("User"));
    this.client.userName = User.fullName;
    if (User.carWash) {
      this.client.carWashName = User.carWash.name;
    }

    this.links = [];
    User.permitionCodeList.forEach((element) => {
      let obj = {
        text: element.text,
        link: element.link,
      };
      this.links.push(obj);
    });    
  },
};
</script>
